import React, { useEffect } from "react";
import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaClock,

} from "react-icons/fa";

import {
  FaBook,
  FaFileInvoiceDollar,
  FaChartLine,
  FaMoneyCheckAlt,
  FaRocket,
  FaArrowRight,
} from "react-icons/fa";
import {
  FaUsers,
  FaLock,
  FaChartBar,
  FaComments,
  FaBolt,
  FaSyncAlt,
} from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import shado from "./shado.png"
import { motion } from "framer-motion";
import "../components/Styles/home.css";
import {Helmet}from"react-helmet";


import AOS from "aos";
import "aos/dist/aos.css";
import Slide from "./Slide";

const Home = () => {

  useEffect(() => {
    AOS.init();
  }, []);
  const services = [
    {
      no: "01",
      icon: <FaBook />,
      title: "Accounting & Bookkeeping",
      desc: "Keep your financial records organized, accurate, and always up to date.",
      items: [
        "Monthly Bookkeeping",
        "General Ledger Management",
        "Bank & Credit Card Reconciliation",
        "Accounts Payable",
        "Accounts Receivable",
        "Financial Statement Preparation",
      ],
    },
    {
      no: "02",
      icon: <FaFileInvoiceDollar />,
      title: "Tax Services",
      desc: "Reduce stress during tax season with professional tax support.",
      items: [
        "Business Tax Preparation",
        "Individual Tax Preparation",
        "Tax Planning",
        "Sales Tax Filing",
        "Estimated Taxes",
        "IRS Assistance",
      ],
    },
    {
      no: "03",
      icon: <FaChartLine />,
      title: "CFO & Financial Advisory",
      desc: "Gain executive-level financial insight without hiring a full-time CFO.",
      items: [
        "Cash Flow Management",
        "Budget Planning",
        "Financial Forecasting",
        "Profitability Analysis",
        "Strategic Growth Planning",
        "Performance Review",
      ],
    },
    {
      no: "04",
      icon: <FaMoneyCheckAlt />,
      title: "Payroll Services",
      desc: "Reliable payroll processing for businesses of all sizes.",
      items: [
        "Payroll Processing",
        "Payroll Tax Filing",
        "Employee Setup",
        "Contractor Payments",
        "Payroll Compliance",
      ],
    },
    {
      no: "05",
      icon: <FaRocket />,
      title: "Business Formation & Startup",
      desc: "Starting a business? We'll help build the right foundation.",
      items: [
        "LLC Formation",
        "EIN Registration",
        "Accounting System Setup",
        "Chart of Accounts",
        "Business Advisory",
      ],
    },
  ];
  const industries = [
    "Professional Service Firms",
    "Construction Companies",
    "Gas Stations & Convenience Stores",
    "Real Estate Businesses",
    "Car Wash Businesses",
    "Retail Businesses",
    "Medical Practices",
    "Restaurants",
    "Multi-Location Businesses",
    "Startups",
    "Entrepreneurs",
  ];
  const features = [
    {
      icon: <FaUsers />,
      title: "Dedicated Financial Experts",
      desc: "Your business is assigned experienced accounting professionals who understand your goals.",
    },
    {
      icon: <FaLock />,
      title: "Secure Client Portal",
      desc: "Upload documents securely, review reports, and access your information anytime.",
    },
    {
      icon: <FaChartBar />,
      title: "Accurate Financial Reporting",
      desc: "Clear financial statements that help you make informed business decisions.",
    },
    {
      icon: <FaComments />,
      title: "Proactive Communication",
      desc: "We help you identify opportunities before they become costly mistakes.",
    },
    {
      icon: <FaBolt />,
      title: "Scalable Solutions",
      desc: "Whether you're starting or managing multiple companies, our services grow with your business.",
    },
    {
      icon: <FaSyncAlt />,
      title: "Technology Driven",
      desc: "Secure cloud-based systems, digital document management, and automated workflows.",
    },
  ];
  const steps = [
    {
      number: "01",
      title: "Book Your Free Consultation",
      desc: "Tell us about your business and your accounting needs.",
    },
    {
      number: "02",
      title: "Receive Your Customized Plan",
      desc: "We'll recommend the services that best fit your business.",
    },
    {
      number: "03",
      title: "Onboarding",
      desc: "We'll gather your financial information and set up your account securely.",
    },
    {
      number: "04",
      title: "We Handle Your Accounting",
      desc: "Our team manages bookkeeping, reporting, payroll, and financial operations.",
    },
  ];
  const features2 = [
    "Secure Document Upload",
    "Financial Reports",
    "Invoice Management",
    "Secure Client Messaging",
    "Dedicated Client Dashboard",
    "Role-Based Access",
    "Monthly Reporting",
    "Workflow Tracking",
  ];
  const faqs = [
    {
      question: "How much do your accounting services cost?",
      answer:
        "Pricing depends on the size of your business and the services you require. We provide customized solutions designed around your specific needs.",
    },
    {
      question: "Do you work with startups?",
      answer:
        "Yes. We help startups with bookkeeping, tax planning, payroll, financial reporting, and business formation.",
    },
    {
      question: "Do I need QuickBooks?",
      answer:
        "Not necessarily. We support QuickBooks and several other accounting platforms depending on your business needs.",
    },
    {
      question: "Can you manage payroll?",
      answer:
        "Absolutely. We provide complete payroll processing, tax filings, employee setup, and compliance support.",
    },
    {
      question: "Do you only serve businesses in Houston?",
      answer:
        "No. We work with businesses remotely across the United States using secure cloud-based systems.",
    },
    {
      question: "Is my financial information secure?",
      answer:
        "Yes. Your data is protected using encrypted cloud storage, secure portals, and industry-standard security practices.",
    },
  ];

  const [active, setActive] = useState(0);

  const toggle = (index) => {
    setActive(active === index ? null : index);
  };
  return (
    <div>
      <Helmet>
      
      <title>Strategic Accounting
Management · Houston</title>
      <meta name="description" content="Discover Xceed Office  premier coworking space in Houston, Texas. Flexible offices, dedicated desks, meeting rooms & business amenities designed for startups, freelancers, and growing teams in TX."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>
      <section className="hero">

<div className="heroLeft">

  <div className="tag">
    HOUSTON • ESTABLISHED FINANCIAL PARTNER
  </div>

  <h1>
    Numbers you can
    <br />
    trust.
  </h1>

  <h2>
    Advice you can act on.
  </h2>

  <p>
    Whether you're a startup, small business, or established
    company, we provide expert bookkeeping, tax support,
    payroll, financial reporting, and strategic CFO advisory
    to help your business grow with confidence.
  </p>

  <div className="features">

    <div>✔ Free Initial Consultation</div>

    <div>✔ Dedicated Accounting Professionals</div>

    <div>✔ Secure Cloud-Based Documents</div>

    <div>✔ Personalized Financial Solutions</div>

  </div>

  <div className="buttons">

    <button className="primary">
      Schedule a Free Consultation →
    </button>

    <button className="secondary">
      Request a Free Quote
    </button>

  </div>

</div>

<div className="heroRight">

  <img src={shado} alt="" />

  <div className="floatingCard">

    <h3>15+</h3>

    <span>Industries Served</span>

  </div>

</div>

</section>
<section className="about-section">
      {/* Top Features */}
      <div id="se2" style={{background:"#FFFFFF",border:"1px solid #e5e2dc"}}>
        <div className="features-row">
        <div className="feature-box">
          <h3>Year-round</h3>
          <p>Financial oversight</p>
        </div>

        <div className="feature-box">
          <h3>Dedicated</h3>
          <p>Accounting team</p>
        </div>

        <div className="feature-box">
          <h3>Secure</h3>
          <p>Cloud platform</p>
        </div>

        <div className="feature-box">
          <h3>Proactive</h3>
          <p>Advisory approach</p>
        </div>
      </div>
      </div>
      

      {/* Bottom Content */}
      <div className="about-content">
        <div className="left-content">
          <span className="sub-title">
            YOUR TRUSTED FINANCIAL PARTNER
          </span>

          <h2>
            Managing your
            <br />
            business finances
            <br />
            shouldn't be stressful.
          </h2>
        </div>

        <div className="right-content">
          <p>
            At Strategic Accounting Management Houston, we become an
            extension of your business by providing accurate bookkeeping,
            reliable accounting, strategic financial planning, and proactive
            business advice so you can focus on growing your company while we
            handle the numbers.
          </p>

          <p>
            Whether you need ongoing bookkeeping, CFO-level guidance,
            payroll management, tax support, or complete financial oversight,
            our experienced professionals are here to help.
          </p>
        </div>
      </div>
    </section>
    <section className="services-section">
      <div className="services-top">

        <div>
          <span className="small-title">OUR SERVICES</span>

          <h2>
            Five practice areas.
            <br />
            <em>One integrated financial team.</em>
          </h2>
        </div>

        <p>
          Every engagement is scoped around your business —
          from monthly bookkeeping to CFO-level strategy.
        </p>

      </div>

      <div className="services-grid">

        {services.map((service) => (
          <div className="service-card" key={service.no}>

            <div className="card-top">
              <div className="icon">{service.icon}</div>
              <span>{service.no}</span>
            </div>

            <h3>{service.title}</h3>

            <p>{service.desc}</p>

            <ul>
              {service.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

          </div>
        ))}

        <div className="cta-card">

          <span>NOT SURE WHERE TO START?</span>

          <h3>
            We'll assemble the right mix for your business.
          </h3>

          <button>
            Talk to an advisor
            <FaArrowRight />
          </button>

        </div>

      </div>
    </section>
    <section className="industries-section">
      <div className="industries-left">
        <span className="section-tag">INDUSTRIES WE SERVE</span>

        <h2>
          Solutions
          <br />
          tailored to how
          <br />
          you actually
          <br />
          operate.
        </h2>

        <p>
          Every industry has its own rhythms, margins, and reporting
          quirks. We speak yours.
        </p>
      </div>

      <div className="industries-right">
        {industries.map((item, index) => (
          <div className="industry-item" key={index}>
            <span className="number">
              {(index + 1).toString().padStart(2, "0")}
            </span>

            <span style={{color:"black"}} className="title">{item}</span>
          </div>
        ))}

        <div className="industry-box"></div>
      </div>
    </section>
    <section className="why-section">
      <div className="section-heading">
        <span>WHY CHOOSE US</span>

        <h2>
          We work alongside your business —
          <br />
          <em>not just at tax time.</em>
        </h2>

        <p>
          Unlike traditional firms that only prepare your taxes once a year,
          we help improve your financial health year-round.
        </p>
      </div>

      <div className="why-grid">
        {features.map((item, index) => (
          <div className="why-card" key={index}>
            <div className="corner"></div>

            <div className="icon">{item.icon}</div>

            <h3>{item.title}</h3>

            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
    <section className="process-section">
      <div className="process-header">
        <span>HOW IT WORKS</span>
        <h2>Four steps to clarity.</h2>
      </div>

      <div className="process-grid">
        {steps.map((step) => (
          <div className="process-card" key={step.number}>
            <h1>{step.number}</h1>
            <h3>{step.title}</h3>
            <p>{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
    <section className="technology-section">
      <div className="technology-left">
        <span className="section-tag">OUR TECHNOLOGY</span>

        <h2>
          A secure platform,
          <br />
          built for
          <br />
          collaboration.
        </h2>

        <p>
          Your financial information is protected through secure
          cloud-based systems that make working with your accountant
          simple and efficient.
        </p>

        <div className="tech-note">
          <FaLock />
          <span>
            Secure cloud storage, role-based access, and full audit
            trails on every document.
          </span>
        </div>
      </div>

      <div className="technology-right">
        {features2.map((item, index) => (
          <div className="tech-item" key={index}>
            <span className="number">
              {(index + 1).toString().padStart(2, "0")}
            </span>

            <span className="title">{item}</span>


          </div>
        ))}
      </div>
    </section>
    <section className="faq-section">
      <span className="faq-tag">FAQ</span>

      <h2>Frequently asked questions</h2>

      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div className="faq-item" key={index}>
            <button
              className="faq-question"
              onClick={() => toggle(index)}
            >
              {faq.question}

              {active === index ? <FaChevronUp /> : <FaChevronDown />}
            </button>

            {active === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
    <section style={{background:"#F8F1E3"}} className="contact-section">
     
     
      <div className="contact-left">
        <span className="section-tag">GET IN TOUCH</span>

        <h2>
          Ready to simplify
          <br />
          your business
          <br />
          finances?
        </h2>

        <p>
          Whether you need bookkeeping, accounting, payroll, tax support,
          or strategic financial guidance, our team is ready to help.
          Schedule your free consultation today.
        </p>

        <div className="contact-info">
          <div className="info-item">
            <div className="icon-box">
              <FaEnvelope />
            </div>
            <span>info@yourdomain.com</span>
          </div>

          <div className="info-item">
            <div className="icon-box">
              <FaPhoneAlt />
            </div>
            <span>(713) XXX-XXXX</span>
          </div>

          <div className="info-item">
            <div className="icon-box">
              <FaClock />
            </div>
            <span>Mon – Fri • 8:00 AM – 6:00 PM</span>
          </div>
        </div>
      </div>

      <div className="contact-form">
        <form>
          <div className="form-grid">
            <div className="form-group">
              <label>FULL NAME *</label>
              <input type="text" />
            </div>

            <div className="form-group">
              <label>COMPANY NAME</label>
              <input type="text" />
            </div>

            <div className="form-group">
              <label>EMAIL ADDRESS *</label>
              <input type="email" />
            </div>

            <div className="form-group">
              <label>PHONE NUMBER *</label>
              <input type="text" />
            </div>

            <div className="form-group">
              <label>INDUSTRY</label>
              <input type="text" />
            </div>

            <div className="form-group">
              <label>NUMBER OF EMPLOYEES</label>
              <input type="text" />
            </div>
          </div>

          <div className="form-group full-width">
            <label>CURRENT ACCOUNTING SOFTWARE (OPTIONAL)</label>
            <input type="text" />
          </div>

          <div className="form-group full-width">
            <label>TELL US ABOUT YOUR BUSINESS</label>
            <textarea
              rows="5"
              placeholder="Share your goals or challenges..."
            ></textarea>
          </div>

          <button className="submit-btn">
            Schedule My Free Consultation
            <FaArrowRight />
          </button>
        </form>
      </div>

    </section>
    </div>
  );
};

export default Home;



